import * as THREE from 'three';
import Experience from '../Experience.js';

export default class Rør {
    constructor() {
        this.experience = new Experience();
        this.camera = this.experience.camera
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.instance = this.camera.instance;
       
        this.resource = this.resources.items.rør;
        this.model = null;
        this.centerCurve = null; // Senterlinje for røret
        this.particleMesh = null; // Partikkel som skal følge banen

        this.setMaterial()
        this.setModel();
    }

    setModel() {
        
        this.model = this.resource.scene 
        console.log(this.model);
        
        
        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.castShadow = true;
                child.receiveShadow = true;
                
                if (child.name === 'kv002') {
                    child.material = this.kaldtvann; 
                }
                if (child.name === 'orasnje-vv-kv002') {
                    child.material = this.varmtvann; 
                }
                if (child.name === 'vv002') {
                    child.material = this.returvann; 
                }
            }
        });
        this.scene.add(this.model);
        
    }

    setMaterial(){
        const lagMaterial = (start, end) => {
        return new THREE.ShaderMaterial({
            side: THREE.DoubleSide,
            transparent: true,

            uniforms: {
                time: { value: 0.0 },
                speed: { value: 2.0 },
                frequency: { value: 300.0 },
                amplitude: { value: 0.2 },
                startColor: { value: new THREE.Color(start) },
                endColor: { value: new THREE.Color(end) }
            },

            vertexShader: `
                varying vec2 vUv;

                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,

            fragmentShader: `
                uniform float time;
                uniform float speed;
                uniform float frequency;
                uniform float amplitude;

                uniform vec3 startColor;
                uniform vec3 endColor;

                varying vec2 vUv;

                void main() {
                    float wave = sin(vUv.x * frequency - time * speed) * amplitude;
                    float alpha = smoothstep(0.4, 1.0, wave + 0.65);

                    // 🔥 Gradient langs røret
                    vec3 colorGradient = mix(startColor, endColor, vUv.x);

                    // 🔥 Litt glow/variation fra bølgen
                    vec3 color = mix(colorGradient, vec3(1.0), wave);

                    gl_FragColor = vec4(color, alpha);
                }
            `
        });
    };
    
    this.kaldtvann = lagMaterial(0x0000ff, 0x00ffff); // blå → cyan
    this.returvann = lagMaterial(0xffff00, 0xffff00); // rød → gul
    this.varmtvann = lagMaterial(0xff9645, 0xff0000);  // oransje til rød
    this.returvann.uniforms.frequency.value = 160.0
    this.varmtvann.uniforms.frequency.value = 240.0

        this.electricMaterial = new THREE.ShaderMaterial({
            side: THREE.DoubleSide,
            transparent: true, // Viktig for lys-effekt!
            depthWrite: false, // Hindrer at objektet forsvinner bak andre
            uniforms: {
                time: { value: 0.0 },  // Tids-uniform for animasjon
                speed: { value: 2.0 }, // Hastighet på lysbølgen
                glowIntensity: { value: 1.5 } // Hvor sterkt lyset skal gløde
            },
            vertexShader: `
                varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                uniform float time;
                uniform float speed;
                uniform float glowIntensity;
                varying vec2 vUv;
        
                void main() {
                    float wave = sin(vUv.x * 5.0 - time * speed) * 0.5 + 0.5; // Skaper lysbølge
                    float glow = smoothstep(0.3, 1.0, wave * glowIntensity); // Justerer gløden
        
                    vec3 color = mix(vec3(0.0, 0.0, 1.0), vec3(1.0, 1.0, 1.0), wave); // Elektrisk blå til hvit
                    gl_FragColor = vec4(color * glow, glow); // Gjør lyset sterkt og glødende
                }
            `,
        });
    }


    update() {
        if (this.kaldtvann) {
            this.kaldtvann.uniforms.time.value += 0.015; // 📌 Oppdater shader-tiden
        }
        if (this.varmtvann) {
            this.varmtvann.uniforms.time.value -= 0.0125; // 📌 Oppdater shader-tiden
        }
        if (this.returvann) {
            this.returvann.uniforms.time.value += 0.01; // 📌 Oppdater shader-tiden
        }
        // if (this.electricMaterial) {
        //     this.electricMaterial.uniforms.time.value += 0.1; // 📌 Oppdater shader-tiden
        // }
    }
}